import React, { useMemo } from 'react';
import { VesselBaylengthGraphProps } from '../types';
import BayDetailsTable from './commonTableWithoutHeaderColumn';

function VesselBayLengthGraph({ bayDetails, primaryColor }:VesselBaylengthGraphProps) {
  const configuration = useMemo(() => {
    if (!bayDetails.IsOTE) {
      return bayDetails?.Configuration;
    }
    return [...bayDetails.Configuration].reverse();
  }, [bayDetails.IsOTE, bayDetails?.Configuration]);

  const isDenseConfiguration = (configuration?.length ?? 0) > 33;

  const getSupportClass = (index: number) => {
    if (!isDenseConfiguration) {
      return 'support-top';
    }

    return index % 2 === 0 ? 'support-bottom' : 'support-top';
  };

  return (
    <>
      <div className="bayLengthHeader">
        <div className="pt10">
          {bayDetails.VesselName}
          {' '}
          (Length =
          {' '}
          {`${bayDetails.TubeLength}`}
          {' '}
          inches)
        </div>
        <div>S = Intermediate Support</div>
      </div>
      <div className="w100 mt10 noTableBreak">
        <div className="cylinder-label-box">
          <div className="label" style={{ color: primaryColor }}>{bayDetails.IsOTE ? 'Opp. Test End' : 'Test End'}</div>
          <div className="label" style={{ color: primaryColor }}>{bayDetails.IsOTE ? 'Test End' : 'Opp. Test End'}</div>
        </div>
        <div className={isDenseConfiguration ? 'cylinder-container long-config-container' : 'cylinder-container'}>
          {configuration?.map((value, index) => (
            <div
              className={isDenseConfiguration ? 'bay bay-dense' : 'bay'}
              style={{
                width: `${(value / Number(bayDetails?.TubeLength)) * 100}%`,
                borderColor: primaryColor,
              }}
              key={`${value}-${index + 1}`}
            >
              {index === 0
              && <div className="left-arc" style={{ borderColor: primaryColor, backgroundColor: primaryColor }} />}
              <div className="content">
                {bayDetails?.Configuration?.length < 15
                && (
                <p className="size fs14" style={{ color: primaryColor }}>
                  {value.toFixed(2)}
                  &quot;
                </p>
                )}
                <p className={`bay-label ${bayDetails?.Configuration?.length > 15 ? 'fs10' : 'fs14'}`}>
                  {isDenseConfiguration
                    ? (
                      <>
                        B
                        <br />
                        {bayDetails.Configuration.length - index}
                      </>
                    )
                    : (
                      <>
                        {bayDetails?.Configuration?.length > 15 ? 'B' : 'Bay'}
                        {bayDetails.Configuration.length - index}
                      </>
                    )}
                </p>
                <div className="arc" style={{ borderColor: primaryColor }} />
              </div>
              <div
                className={[
                  bayDetails?.Configuration?.length > 15 ? 's-label fs10' : 's-label fs14',
                  getSupportClass(index),
                ].join(' ')}
                style={{ color: primaryColor }}
              >
                {(index < configuration.length - 1) ? `S${configuration.length - index - 1}` : ''}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bayLengthTableBox w100 mt30 mb30">
        {bayDetails?.Configuration?.length > 0
        && (
        <div className="textCenter centerAlign">
          <BayDetailsTable data={bayDetails?.Configuration} primaryColor={primaryColor} />
        </div>
        )}
      </div>
    </>
  );
}

export default VesselBayLengthGraph;

// code for split baylength tube into two parts

// import React, { useMemo } from 'react';
// import { VesselBaylengthGraphProps } from '../types';
// import BayDetailsTable from './commonTableWithoutHeaderColumn';

// function VesselBayLengthGraph({ bayDetails, primaryColor }:VesselBaylengthGraphProps) {
//   const configuration = useMemo(() => {
//     if (!bayDetails.IsOTE) {
//       return bayDetails?.Configuration;
//     }
//     return [...bayDetails.Configuration].reverse();
//   }, [bayDetails.IsOTE, bayDetails?.Configuration]);

//   const configurationSections = useMemo(() => {
//     if (!configuration) return [];

//     // Render long tubes as two scaled sections so the bay labels do not overlap.
//     if (configuration.length <= 33) return [configuration];

//     const splitIndex = Math.ceil(configuration.length / 2);
//     return [configuration.slice(0, splitIndex), configuration.slice(splitIndex)];
//   }, [configuration]);

//   const renderCylinderSection = (section:number[], sectionStartIndex:number) => {
//     const sectionLength = section.reduce((total, value) => total + Number(value), 0);

//     return (
//       <div className="cylinder-container" key={`section-${sectionStartIndex}`}>
//         {configuration.length > 33 && sectionStartIndex > 0
//         && <div className="split-test-end-label" style={{ color: primaryColor }}>Test End</div>}
//         {section.map((value, index) => {
//           const configurationIndex = sectionStartIndex + index;

//           return (
//             <div
//               className="bay"
//               style={{
//                 width: `${(Number(value) / sectionLength) * 100}%`,
//                 borderColor: primaryColor,
//               }}
//               key={`${value}-${configurationIndex + 1}`}
//             >
//               {index === 0
//               && <div className="left-arc" style={{ borderColor: primaryColor, backgroundColor: primaryColor }} />}
//               <div className="content">
//                 {bayDetails?.Configuration?.length < 15
//                 && (
//                 <p className="size fs14" style={{ color: primaryColor }}>
//                   {value.toFixed(2)}
//                   &quot;
//                 </p>
//                 )}
//                 <p className={bayDetails?.Configuration?.length > 15 ? 'fs10' : 'fs14'}>
//                   {bayDetails?.Configuration?.length > 15 ? 'B' : 'Bay'}
//                   {bayDetails.Configuration.length - configurationIndex}
//                 </p>
//                 <div className="arc" style={{ borderColor: primaryColor }} />
//               </div>
//               <div className={bayDetails?.Configuration?.length > 15 ? 's-label fs10' : 's-label fs14'} style={{ color: primaryColor }}>
//                 {(configurationIndex < configuration.length - 1) ? `S${configuration.length - configurationIndex - 1}` : ''}
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="bayLengthHeader">
//         <div className="pt10">
//           {bayDetails.VesselName}
//           {' '}
//           (Length =
//           {' '}
//           {`${bayDetails.TubeLength}`}
//           {' '}
//           inches)
//         </div>
//         <div>S = Intermediate Support</div>
//       </div>
//       <div className="w100 mt10 noTableBreak">
//         <div className="cylinder-label-box">
//           {(configuration.length <= 33 || bayDetails.IsOTE)
//           && <div className="label" style={{ color: primaryColor }}>{bayDetails.IsOTE ? 'Opp. Test End' : 'Test End'}</div>}
//           {(configuration.length <= 33 || !bayDetails.IsOTE)
//           && <div className="label" style={{ color: primaryColor }}>{bayDetails.IsOTE ? 'Test End' : 'Opp. Test End'}</div>}
//         </div>
//         {configurationSections.map((section, index) => renderCylinderSection(
//           section,
//           configurationSections.slice(0, index).reduce((count, currentSection) => count + currentSection.length, 0),
//         ))}
//       </div>
//       <div className="bayLengthTableBox w100 mt30 mb30">
//         {bayDetails?.Configuration?.length > 0
//         && (
//         <div className="textCenter centerAlign">
//           <BayDetailsTable data={bayDetails?.Configuration} primaryColor={primaryColor} />
//         </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default VesselBayLengthGraph;

// ..................................................

// default code

// import React, { useMemo } from 'react';
// import { VesselBaylengthGraphProps } from '../types';
// import BayDetailsTable from './commonTableWithoutHeaderColumn';

// function VesselBayLengthGraph({ bayDetails, primaryColor }:VesselBaylengthGraphProps) {
//   const configuration = useMemo(() => {
//     if (!bayDetails.IsOTE) {
//       return bayDetails?.Configuration;
//     }
//     return [...bayDetails.Configuration].reverse();
//   }, [bayDetails.IsOTE, bayDetails?.Configuration]);
//   return (
//     <>
//       <div className="bayLengthHeader">
//         <div className="pt10">
//           {bayDetails.VesselName}
//           {' '}
//           (Length =
//           {' '}
//           {`${bayDetails.TubeLength}`}
//           {' '}
//           inches)
//         </div>
//         <div>S = Intermediate Support</div>
//       </div>
//       <div className="w100 mt10 noTableBreak">
//         <div className="cylinder-label-box">
//           <div className="label" style={{ color: primaryColor }}>{bayDetails.IsOTE ? 'Opp. Test End' : 'Test End'}</div>
//           <div className="label" style={{ color: primaryColor }}>{bayDetails.IsOTE ? 'Test End' : 'Opp. Test End'}</div>
//         </div>
//         <div className="cylinder-container">
//           {configuration?.map((value, index) => (
//             <div
//               className="bay"
//               style={{
//                 width: `${(value / Number(bayDetails?.TubeLength)) * 100}%`,
//                 borderColor: primaryColor,
//               }}
//               key={`${value}-${index + 1}`}
//             >
//               {index === 0
//               && <div className="left-arc" style={{ borderColor: primaryColor, backgroundColor: primaryColor }} />}
//               <div className="content">
//                 {bayDetails?.Configuration?.length < 15
//                 && (
//                 <p className="size fs14" style={{ color: primaryColor }}>
//                   {value.toFixed(2)}
//                   &quot;
//                 </p>
//                 )}
//                 <p className={bayDetails?.Configuration?.length > 15 ? 'fs10' : 'fs14'}>
//                   {bayDetails?.Configuration?.length > 15 ? 'B' : 'Bay'}
//                   {bayDetails.Configuration.length - index}
//                 </p>
//                 <div className="arc" style={{ borderColor: primaryColor }} />
//               </div>
//               <div className={bayDetails?.Configuration?.length > 15 ? 's-label fs10' : 's-label fs14'} style={{ color: primaryColor }}>
//                 {(index < configuration.length - 1) ? `S${configuration.length - index - 1}` : ''}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="bayLengthTableBox w100 mt30 mb30">
//         {bayDetails?.Configuration?.length > 0
//         && (
//         <div className="textCenter centerAlign">
//           <BayDetailsTable data={bayDetails?.Configuration} primaryColor={primaryColor} />
//         </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default VesselBayLengthGraph;
